import { gql, useMutation } from "@apollo/client";

const CREATE_ACCOUNT_MUTATION = gql`
  mutation CreateNewDesignerAccount(
    $email: String!
    $password: String!
    $accountType: UserAccountType!
    $phoneNumber: String
    $firstName: String
    $lastName: String
    $businessName: String
    $businessAddress: String
    $businessCity: String
    $businessState: States
    $businessZipCode: String
    $businessWebsite: String
    $idempotencyKey: String
    $attribution: AttributionInput
  ) {
    createNewDesignerAccount(
      email: $email
      password: $password
      accountType: $accountType
      phoneNumber: $phoneNumber
      firstName: $firstName
      lastName: $lastName
      businessName: $businessName
      businessAddress: $businessAddress
      businessCity: $businessCity
      businessState: $businessState
      businessZipCode: $businessZipCode
      businessWebsite: $businessWebsite
      idempotencyKey: $idempotencyKey
      attribution: $attribution
    )
  }
`;

export const useCreateDesignerAccountMutation = () => {
  const [createDesignerAccount, { loading, error, data }] = useMutation(
    CREATE_ACCOUNT_MUTATION
  );

  return { createDesignerAccount, loading, error, data };
};
